import { useMemo } from 'react'
import { useFiltersStore } from '@/hooks'
import { useBillingFiltersStore } from '@/features/BillingPayments/stores/useBillingFiltersStore/useBillingFiltersStore'
import { mapBillingFiltersSaveParams } from '@/features/BillingPayments/stores/useBillingFiltersStore/mapBillingFiltersSaveParams'

export const useBillingFiltersSaveParams = () => {
    const activeBillingFilters = useBillingFiltersStore(
        (state) => state.activeFilters
    )
    const rootNode = useFiltersStore((state) => state.rootNode)

    const billingFiltersParams = useMemo(() => {
        const passedFilters = Object.assign({}, activeBillingFilters)

        if (!passedFilters.node.length && rootNode) {
            passedFilters.node = [rootNode.nodeId]
        }

        return mapBillingFiltersSaveParams(passedFilters)
    }, [activeBillingFilters, rootNode])

    return billingFiltersParams
}
